import React from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import {
    // setMatrixSellModalStatus,
    setMatrixSellSuccessModalStatus,
    // setMatrixSellWarningModalStatus
} from "../../store/cabinet/action";
// import cfpIcon from "../../theme/assets/other/ftf_cfp_icon.png";



const CabinetMatrixSellSuccessModal = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const matrixSellSuccessModalStatus = useSelector(store => store.cabinet.matrixSellSuccessModalStatus);

    const closeModal = () =>{
        dispatch(setMatrixSellSuccessModalStatus(false));
    }

    const mainBtnHandler = () =>{
        closeModal();
    }

    return (
        <DsModal
            open={matrixSellSuccessModalStatus}
            onClose={closeModal}
            size="sm"
            title={t('Готово!')}
        >
            <div className={Form.note}>
                {t('Ваши токены добавлены в общий пул нового круга. Как только круг будет полностью распродан, деньги автоматически поступят на ваш баланс!')}
            </div>
            <button type="button" className={Form.btnAccent} onClick={mainBtnHandler}>{t('Отлично!')}</button>
        </DsModal>
    );
};

export default CabinetMatrixSellSuccessModal;
